//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import i18 from '../../i18'
import NotificationSystem from 'react-notification-system'
import api from '../../source/api'
import Row from './rules/row'
import Modal from 'react-modal'
import Field from '../common/Field'
import Validator from '../common/Validator'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

Modal.setAppElement('#root');

class Rules extends Component {

    constructor(props) {
        super(props);
        this._notificationSystem = null;
        this.state = {
            modalIsOpen: false,
            company_id: props.company_id,
            company: props.company,
            editRule: {},
            supplierRules: props.supplierRules,
            vatCollectorCodes: props.vatCollectorCodes,
            invoices: props.invoices,
            fields: {
                id: {value: '', error: '', role: {required: true}},
                vat_collector_id: {value: '', error: '', role: {required: true}},
                supplier_name: {value: '', error: '', role: {required: false}},
                item_name: {value: '', error: '', role: {required: false}},
                vat: {value: '', error: '', role: {required: true}},
                main_bookkeeping_number: {value: '', error: '', role: {required: true}},
                vat_degree: {value: '', error: '', role: {required: true}},
                type: {value: '', error: '', role: {required: true}},
            },
        };
    };

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        window.scrollTo(0, 0);
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            company: nextProps.company,
            supplierRules: nextProps.supplierRules,
            vatCollectorCodes: nextProps.vatCollectorCodes,
            invoices: nextProps.invoices,
        }
    };

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        });
    };

    onRemoveRule = (rule) => {
        if (window.confirm('Biztos törölni szeretné a szabályt?')) {
            api.delete({url: 'supplier/rule/delete?company_id=' + this.state.company_id + '&id=' + rule.id}, true).then((response) => {
                this.setState({
                    modalIsOpen: false
                });

                let supplierRules = response.data.supplierRules;
                let invoices = this.state.invoices;

                this.props.updateInvoices(invoices, supplierRules);
                this.props.setData({
                    invoices: invoices,
                    supplierRules: supplierRules,
                });

                this._addNotification('Szabály törlése sikeres.', 'success', 10);
            }).catch((err) => {
                console.log(err);
                this.closeModal();
                this._addNotification('Szabály törlése sikertelen.', 'error', 30);
            });
        }
    };

    editRule = (rule) => {
        let fields = this.state.fields;

        fields.id.value = rule.id;
        fields.vat_collector_id.value = rule.vat_collector_id || '';
        fields.supplier_name.value = rule.supplier_name;
        fields.item_name.value = rule.item_name;
        fields.vat.value = rule.vat;
        fields.main_bookkeeping_number.value = rule.main_bookkeeping_number;
        fields.vat_degree.value = rule.vat_degree;
        fields.type.value = rule.type;

        this.setState({
            editRule: rule,
            fields: fields,
            modalIsOpen: true,
        });
    };

    updateRule = () => {
        let validator = Validator.validate(this.state.fields);
        if (validator.error) {
            this.setState({
                fields: validator.fields,
                error: validator.error
            });
            return;
        }

        let postData = {
            id: this.state.fields.id.value,
            supplier_name: this.state.fields.supplier_name.value,
            item_name: this.state.fields.item_name.value,
            vat: this.state.fields.vat.value,
            main_bookkeeping_number: this.state.fields.main_bookkeeping_number.value,
            vat_degree: this.state.fields.vat_degree.value,
            type: this.state.fields.type.value,
            vat_collector_id: this.state.fields.vat_collector_id.value
        };



        api.put({url: 'supplier/rule/update?company_id=' + this.state.company.id, data: postData}, true).then((response) => {
            this.setState({
                modalIsOpen: false
            });

            let supplierRules = response.data.supplierRules;
            let invoices = this.state.invoices;
            this.props.updateInvoices(invoices, supplierRules);
            this.props.setData({
                invoices: invoices,
                supplierRules: supplierRules,
            });
            this._addNotification('Szabály szerkesztése sikeres.', 'success', 10);
        }).catch((err) => {
            console.log(err);
            this.closeModal();
            this._addNotification('Szabály mentése sikertelen.', 'error', 30);
        });
    };

    closeModal = () => {
        this.setState({modalIsOpen: false});
    };

    listInvoices = () => {
        if (this.state.supplierRules.length === 0) {
            return (
                <tr>
                    <td colSpan='9'>{i18.COMMON._noRulesFound}</td>
                </tr>
            );
        }

        let rulesRows = [];
        for (let index in this.state.supplierRules) {
            let rule = this.state.supplierRules[index];
            rulesRows.push(
                <Row
                    _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                    key={rule.id}
                    rule={rule}
                    vatCollectorCodes={this.state.vatCollectorCodes}
                    onRemoveRule={(rule) => this.onRemoveRule(rule)}
                    onEditRule={(rule) => this.editRule(rule)}/>
            );
        }
        return rulesRows;
    };

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    };

    onElementChange = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields});
    };

    hideRulesBox = () => {
        this.props.editRules();
    };

    printPage = () => {
        window.print();
    };

    deleteAllRules = () => {
        if (window.confirm('Biztos törölni szeretné az összes szabályt?')) {
            api.get({url: 'supplier/rules/deleteall?company_id=' + this.state.company.id, data: {}}, true).then((response) => {
                let supplierRules = response.data.supplierRules;
                let invoices = this.state.invoices;
                this.props.updateInvoices(invoices, supplierRules);

                this.setState({
                    modalIsOpen: false
                });

                this.props.setData({
                    invoices: invoices,
                    supplierRules: supplierRules,
                });

                this._addNotification('Az összes szabály törölve lett.', 'success', 10);
            }).catch((err) => {
                console.log(err);
                this.closeModal();
                this._addNotification('Szabályok törlése sikertelen.', 'error', 30);
            });
        }
    };

    render() {
        return (
            <section id='supplier-rules'>
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1>
                                    <a onClick={() => this.hideRulesBox()} className='choose-btn'>{i18.BUTTONS._back}</a>
                                    {i18.SUPPLIER._rulesTitle}
                                </h1>
                                <h4 className='text-left'>Kiválasztott cég : {typeof this.state.company !== 'undefined' ? this.state.company.name : ''}</h4>
                            </div>
                            <div className='col-12'>
                                <p>{i18.SUPPLIER._rulesDescription}</p>
                                <a className='link-color' onClick={() => this.printPage()}>
                                    <i className="fa fa-print" aria-hidden="true"/>&nbsp;{i18.COMMON._printRules}
                                </a>&nbsp;&nbsp;&nbsp;
                                <a className='link-color' onClick={() => this.deleteAllRules()}>
                                    <i className="fa fa-trash-o" aria-hidden="true"/>&nbsp;{i18.COMMON._deleteAllRules}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table table-striped  table-aibook-no-border'>
                                    <thead>
                                    <tr>
                                        <th>Szállító neve</th>
                                        <th>Tétel megnevezés</th>
                                        <th>{i18.SUPPLIER._mainBookNumber}</th>
                                        <th>{i18.SUPPLIER._VAT}</th>
                                        <th>{i18.SUPPLIER._collectorCode}</th>
                                        <th>{i18.SUPPLIER._taxNumber}</th>
                                        <th>{i18.COMMON._typeOfRule}</th>
                                        <th>Módosítva</th>
                                        <th style={{width: '70px'}}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.listInvoices()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.closeModal()}
                    style={customStyles}
                    contentLabel='Szabály szerkesztése'>
                    <h4>{i18.COMMON._editRuleText}</h4>
                    <div className='modal-body'>
                        <Field
                            type='text' id='supplier_name' name='supplier_name'
                            label={i18.SUPPLIER._typeOfTraffic} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='item_name' name='item_name'
                            label={i18.SUPPLIER._typeOfTraffic} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='vat' name='vat'
                            label={i18.SUPPLIER._VAT} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='main_bookkeeping_number' name='main_bookkeeping_number'
                            label={i18.SUPPLIER._mainBookNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='vat_degree' name='vat_degree'
                            label={i18.SUPPLIER._vatDegreeNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <label htmlFor="vat_collector_id" className="margin-top-10 margin-bottom-2 control-label">{i18.SUPPLIER._collectorCode}</label>
                        <select value={this.state.fields.vat_collector_id.value}
                                name='vat_collector_id'
                                id='vat_collector_id'
                                onChange={(codeevent) => this.onElementChange(codeevent)}
                                className='minimal-100  form-control'>
                            <option value='' key='0'>Kérjük válasszon</option>
                            {this.state.vatCollectorCodes.map((el) => {
                                return (
                                    <option
                                        value={el.id}
                                        key={el.id}>
                                        {el.code}&nbsp;({el.title})
                                    </option>
                                )
                            })}
                        </select>
                        <label htmlFor="type" className="margin-top-10 margin-bottom-2 control-label">{i18.COMMON._typeOfRule}</label>
                        <select value={this.state.fields.type.value}
                                name='type'
                                id='type'
                                onChange={(codeevent) => this.onElementChange(codeevent)}
                                className='minimal-100  form-control'>
                            <option value="temporarily">{i18.COMMON._temporarirlyRule}</option>
                            <option value="final">{i18.COMMON._finalRule}</option>
                        </select>
                    </div>

                    <div className='modal-footer text-center'>
                        <a onClick={() => this.updateRule()} className='btn btn-success btn-sm'>{i18.COMMON._save}</a>&nbsp;&nbsp;&nbsp;
                        <a onClick={() => this.closeModal()} className='btn btn-danger btn-sm'>{i18.COMMON._close}</a>
                    </div>
                </Modal>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        );
    };
}

export default Rules;




// WEBPACK FOOTER //
// ./src/components/supplier/rules.js